export default __webpack_public_path__ + "static/media/pds_nptel.0cf816ce.png";